<script>
// Custom Components
import PageHeader from "@/components/page-header";

import appConfig from "@/app.config";
import errorHandler from "@/helpers/errorHandler";
import iotService from "@/helpers/APIService/iot.service";

export default {
  page: {
    title: "Gateway",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      title: "List Of IOT Gateway",
      isLoading: false,
      gatewayList: [],
    };
  },
  components: {
    PageHeader,
  },
  mounted() {
    this.getGateways();
  },
  methods: {
    // Method is used to get gateway list
    async getGateways() {
      this.isLoading = true;
      try {
        const response = await iotService.getLockGatewayList();
        if (response) {
          this.gatewayList = response;
          this.isLoading = false;
        }
      } catch (error) {
        this.isLoading = false;
        errorHandler(error);
      }
    },
    // Method is used to handle redirection of gateway to device
    redirectToListOfDevice(id) {
      this.$router.push(`/device-list/${id}`);
    },
  },
};
</script>

<template>
  <div>
    <PageHeader :title="title" />
    <div class="card">
      <div class="card-body">
        <div class="table-responsive mb-0">
          <v-table
            :data="gatewayList"
            class="table table-hover mb-0"
            ref="my-table"
          >
            <thead class="table-light" slot="head">
              <tr>
                <v-th sortKey="mac_address">Mac Address</v-th>
                <v-th sortKey="ip_address">IP Address</v-th>
                <v-th sortKey="name">Device name</v-th>
                <th>Created by</th>
                <th>Updated by</th>
                <th>Last Config</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody
              class="infinite-list"
              slot="body"
              slot-scope="{ displayData }"
              v-if="!isLoading && gatewayList.length !== 0"
            >
              <tr
                v-for="(gateway, index) in displayData"
                :key="index"
                @click="redirectToListOfDevice(gateway.id)"
              >
                <td>
                  {{ gateway.mac_address !== null ? gateway.mac_address : "-" }}
                </td>
                <td>
                  {{ gateway.ip_address !== null ? gateway.ip_address : "-" }}
                </td>
                <td>
                  {{ gateway.name !== null ? gateway.name : "-" }}
                </td>
                <td>
                  {{ gateway.created_by !== null ? gateway.created_by : "-" }}
                </td>
                <td>
                  {{ gateway.updated_by !== null ? gateway.updated_by : "-" }}
                </td>
                <td>
                  {{
                    global_format_date_and_time_custom(
                      gateway.last_config_at,
                      "YYYY-MM-DD hh:mm A"
                    )
                  }}
                </td>
                <td>
                  <div class="form-check form-switch my-1" slot="is_active">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="gateway.is_active"
                      disabled
                    />
                  </div>
                </td>
                <td>
                  <i class="mdi mdi-eye fs-5 text-success"></i>
                </td>
              </tr>
            </tbody>
            <tbody slot="body" v-else-if="isLoading">
              <tr v-for="item in 10" :key="item">
                <td class="placeholder-glow" v-for="no in 8" :key="no">
                  <span class="placeholder w-100 placeholder-lg"></span>
                </td>
              </tr>
            </tbody>
            <tbody slot="body" v-else>
              <tr>
                <td colspan="9" class="text-center">
                  <img
                    src="@/assets/images/empty.svg"
                    class="img-fluid"
                    alt=""
                  />
                  <p>
                    <span class="text-secondary">No Data Found</span>
                  </p>
                </td>
              </tr>
            </tbody>
          </v-table>
        </div>
      </div>
    </div>
  </div>
</template>
